module.exports = __webpack_public_path__ + "static/media/article4.c7b702b1.webp";